import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import EditCategory from '../containers/EditCategory'

class ItemShowView extends Component {

  render() {
    document.body.className = window.location.pathname.replace(/\//g," ");

    const item_id = this.props.match.params.id;

    if (this.props.item_ids.indexOf(item_id) === -1){
      return (<Redirect to="/snap-photo" />)
    }else{
      if (this.props.current_user.get("deleting_an_item") === true){
        return (<Redirect to="/snap-photo" />)
      }else{
        const item = this.props.items_by_id.get(item_id)
        return (
          <div>
             <div className="container topbar bk-dark">
              <div className="back"><Link to="/snap-photo">« Back</Link></div>
              <div className="title">{item.get("name")}</div>
            </div>
             <div className="content">
            <img src={item.get("box_image_url")} alt="" />
            </div>

            { this.props.current_user.get("syncing_item_props") === true ?
              <p>Updating item...</p>
              :
              <div className="edit-category padding-10x text-button">
                <div>{ this.props.current_user.get("changing_category") === true ?
                  <div>
                    <div className="button secondary" onClick={this.props.handleChangeCategoryCancel}>Cancel</div>
                       <div className="swipeable category-scroll">
                        { this.props.categories.valueSeq().map((category) =>
                          <EditCategory key={category.get("id")} id={category.get("id")} name={category.get("name")} icon_url={category.get("icon_url")} item_id={item_id} />
                        )}
                      </div>
                   </div>
                  :
                  <button onClick={this.props.handleChangeCategoryClick}>Change Category</button>
                  }
                  <div className="centered"><Link to={`/item/${item_id}/edit`}>Edit Title &amp; Description</Link></div>
                  <button className="secondary" onClick={this.props.handleDeleteClick}>Delete</button>

                </div>
              </div>
            }

          </div>
        )
      }
    }
  }
}

// WelcomeView.propTypes = {
//   current_user_id: PropTypes.number
// };

export default ItemShowView;



// WEBPACK FOOTER //
// ./src/snapit_app/components/ItemShowView.js